module.exports = __webpack_public_path__ + "static/media/mp3.ae228868.png";